import React from 'react';
import { Message, Language } from '../config/types';
import { labels } from '../config/constants';

interface MessageHistoryProps {
  messages: Message[];
  language: Language;
}

export const MessageHistory: React.FC<MessageHistoryProps> = ({ messages, language }) => (
  <div className="mt-4">
    <h2 className="text-lg font-semibold mb-2 text-gray-800">
      {labels[language].messageHistory}
    </h2>
    <ul className="space-y-2 max-h-64 overflow-y-auto">
      {messages
        .slice(0, -1)
        .slice()
        .reverse()
        .map((message, index) => (
          <li
            key={index}
            className={`p-2 rounded-lg shadow-sm ${
              message.role === 'user'
                ? 'bg-gray-700 text-white'
                : 'bg-gray-300 text-gray-800'
            }`}
          >
            <span className="block">{message.content}</span>
          </li>
        ))}
    </ul>
  </div>
);